import type { SVGProps } from 'react';

const SvgPlayerPlaybackOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 7v3c0 .55.45 1 1 1s1-.45 1-1V7c0-2.21-1.79-4-4-4H7C4.79 3 3 4.79 3 7v4c0 2.21 1.79 4 4 4h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2"
    />
    <path
      fill="currentcolor"
      d="M15 17v-3c0-.55-.45-1-1-1s-1 .45-1 1v3c-.55 0-1 .45-1 1s.45 1 1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c.55 0 1-.45 1-1s-.45-1-1-1m5-2v-1c0-.55-.45-1-1-1s-1 .45-1 1v1c-.55 0-1 .45-1 1s.45 1 1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c.55 0 1-.45 1-1s-.45-1-1-1m-5.06-6.34-4.52-2.61a.358.358 0 0 0-.54.31v5.22c0 .28.3.45.54.31l4.52-2.61c.24-.14.24-.48 0-.62"
    />
  </svg>
);
export default SvgPlayerPlaybackOptions;
